<div class="flex flexJustify--between">
    <mat-form-field class="col__ col__md--60">
        <mat-label>Day Of Week</mat-label>
        <mat-select placeholder="Day of Week"
                    [ngModel]="day"
                    (ngModelChange)="dayChanged($event)">
            <mat-option [value]="'monday'">Monday</mat-option>
            <mat-option [value]="'tuesday'">Tuesday </mat-option>
            <mat-option [value]="'wednesday'">Wednesday </mat-option>
            <mat-option [value]="'thursday'">Thursday </mat-option>
            <mat-option [value]="'friday'">Friday </mat-option>
            <mat-option [value]="'saturday'">Saturday </mat-option>
            <mat-option [value]="'sunday'">Sunday </mat-option>

        </mat-select>
    </mat-form-field>

    <mat-form-field class="col__ col__md--35">
        <mat-label>Time</mat-label>
        <mat-select placeholder="Time"
                    [ngModel]="time"
                    (ngModelChange)="onTimeChanged($event)">
            <mat-option [value]="opt.value"
                        *ngFor="let opt of timeOptions">{{opt.text}}</mat-option>
        </mat-select>
    </mat-form-field>
</div>
